import * as moment from "moment";
import { BIG_LOGO } from "./contantsTemplate";
moment.locale('es')

export const pdfReporteActividadTemplate = async (activitySummary: any): Promise<any> => {

  // Encabezados de las tablas de detalle
  const storageHeaders = [
    { text: 'Contenedor', style: 'headerTableData' },
    { text: 'Tipo', style: 'headerTableData' },
    { text: 'Conductor', style: 'headerTableData' },
    { text: 'Cédula', style: 'headerTableData' },
    { text: 'Teléfono', style: 'headerTableData' },
    { text: 'Placa', style: 'headerTableData' },
    { text: 'Descripción', style: 'headerTableData' },
    { text: 'Fecha ingreso', style: 'headerTableData' },
    { text: 'Fecha salida', style: 'headerTableData' },
    { text: 'Estado', style: 'headerTableData' },
    { text: 'Descuento', style: 'headerTableData' },
    { text: 'Valor', style: 'headerTableData' }
  ];

  const transshipmentHeaders = [
    { text: 'Contenedor', style: 'headerTableData' },
    { text: 'Tipo', style: 'headerTableData' },
    { text: 'Conductor', style: 'headerTableData' },
    { text: 'Cédula', style: 'headerTableData' },
    { text: 'Teléfono', style: 'headerTableData' },
    { text: 'Placa', style: 'headerTableData' },
    { text: 'Descripción', style: 'headerTableData' },
    { text: 'Fecha proceso', style: 'headerTableData' },
    { text: 'Tarifa', style: 'headerTableData' },
    { text: 'Descuento', style: 'headerTableData' },
    { text: 'Valor', style: 'headerTableData' }
  ];

  // Filas de detalle de almacenamiento
  const storageRows = [
    ...activitySummary.details.storage.containersInList.map(item => [
      { text: item.container },
      { text: item.ContainerType?.name || '' },
      { text: item.driverName },
      { text: item.driverId },
      { text: item.driverPhone },
      { text: item.vehiclePlate },
      { text: item.description },
      { text: item.date ? moment(item.date).format('YYYY-MM-DD HH:mm') : '' },
      { text: item.checkOutDate ? moment(item.checkOutDate).format('YYYY-MM-DD HH:mm') : '' },
      { text: item.status === 'pending' ? 'Pendiente' : item.status === 'finished' ? 'Finalizado' : item.status === 'canceled' ? 'Cancelado' : item.status === 'transshipment' ? 'Transbordo' : '' },
      { text: item.discount ? `$${Number(item.discount).toLocaleString('es-CO')}` : '' },
      { text: item.amount ? `$${Number(item.amount).toLocaleString('es-CO')}` : '' }
    ]),
    ...activitySummary.details.storage.containersOutList.map(item => [
      { text: item.container },
      { text: item.ContainerType?.name || '' },
      { text: item.driverName },
      { text: item.driverId },
      { text: item.driverPhone },
      { text: item.vehiclePlate },
      { text: item.description },
      { text: item.date ? moment(item.date).format('YYYY-MM-DD HH:mm') : '' },
      { text: item.checkOutDate ? moment(item.checkOutDate).format('YYYY-MM-DD HH:mm') : '' },
      { text: item.status === 'pending' ? 'Pendiente' : item.status === 'finished' ? 'Finalizado' : item.status === 'canceled' ? 'Cancelado' : item.status === 'transshipment' ? 'Transbordo' : '' },
      { text: item.discount ? `$${Number(item.discount).toLocaleString('es-CO')}` : '' },
      { text: item.amount ? `$${Number(item.amount).toLocaleString('es-CO')}` : '' }
    ]),
    ...activitySummary.details.storage.containersPendingList.map(item => [
      { text: item.container },
      { text: item.ContainerType?.name || '' },
      { text: item.driverName },
      { text: item.driverId },
      { text: item.driverPhone },
      { text: item.vehiclePlate },
      { text: item.description },
      { text: item.date ? moment(item.date).format('YYYY-MM-DD HH:mm') : '' },
      { text: '' },
      { text: item.status === 'pending' ? 'Pendiente' : item.status === 'finished' ? 'Finalizado' : item.status === 'canceled' ? 'Cancelado' : item.status === 'transshipment' ? 'Transbordo' : '' },
      { text: item.discount ? `$${Number(item.discount).toLocaleString('es-CO')}` : '' },
      { text: '' }
    ])
  ];

  // Filas de detalle de transbordo
  const transshipmentRows = activitySummary.details.transshipment.containersProcessedList.map(item => [
    { text: item.container },
    { text: item.containerType },
    { text: item.driverName },
    { text: item.driverId },
    { text: item.driverPhone },
    { text: item.vehiclePlate },
    { text: item.description },
    { text: item.processedAt ? moment(item.processedAt).format('YYYY-MM-DD HH:mm') : '' },
    { text: item.transhipRate ? `$${Number(item.transhipRate).toLocaleString('es-CO')}` : '' },
    { text: item.discount ? `$${Number(item.discount).toLocaleString('es-CO')}` : '' },
    { text: item.amount ? `$${Number(item.amount).toLocaleString('es-CO')}` : '' }
  ]);

  // Resumen por tipo de contenedor
  const byContainerTypeRows = [
    [
      { text: 'Tipo', style: 'headerTableData' },
      { text: 'Almacenados', style: 'headerTableData' },
      { text: 'Pendientes', style: 'headerTableData' },
      { text: 'Transbordos', style: 'headerTableData' },
      { text: 'Ingresos', style: 'headerTableData' }
    ],
    ...activitySummary.byContainerType.map(type => [
      { text: type.typeName },
      { text: type.storage.containersIn },
      { text: type.storage.containersPending },
      { text: type.transshipment.containersProcessed },
      { text: `$${Number(type.storage.revenue + type.transshipment.revenue).toLocaleString('es-CO')}` }
    ])
  ];

  // Resumen general
  const summaryRows = [
    [
      { text: 'Ingresados', style: 'headerTableStatistical' },
      { text: activitySummary.summary.storage.containersIn, alignment: 'center' }
    ],
    [
      { text: 'Finalizados', style: 'headerTableStatistical' },
      { text: activitySummary.summary.storage.containersOut, alignment: 'center' }
    ],
    [
      { text: 'Pendientes', style: 'headerTableStatistical' },
      { text: activitySummary.summary.storage.containersPending, alignment: 'center' }
    ],
    [
      { text: 'Transbordos', style: 'headerTableStatistical' },
      { text: activitySummary.summary.transshipment.containersProcessed, alignment: 'center' }
    ],
    [
      { text: 'Total movimientos', style: 'headerTableStatistical' },
      { text: activitySummary.summary.total.totalTransactions, alignment: 'center' }
    ],
    [
      { text: 'Ingresos totales', style: 'headerTableStatistical' },
      { text: `$${Number(activitySummary.summary.total.totalRevenue).toLocaleString('es-CO')}`, alignment: 'center' }
    ]
  ];

  return {
    footer: function (currentPage, pageCount) {
      return {
        columns: [
          { text: 'DIRECCIÓN: VIA ALTERNA KM-7 CALLE 15A # 47 BIS - 11 - BUENAVENTURA', style: 'footer' },
          { text: 'PÁGINA ' + currentPage.toString() + ' DE ' + pageCount, alignment: 'right', style: 'footer' }
        ], margin: [20, 3, 20, 0]
      }
    },
    pageSize: 'legal',
    pageMargins: [20, 20, 20, 25],
    pageOrientation: 'landscape',
    content: [
      {
        image: BIG_LOGO,
        alignment: 'center'
      },
      {
        text: '"PIKI7 SAS"', fontSize: 12, bold: true, alignment: 'center'
      },
      {
        text: 'NIT. 900.368.831-9', fontSize: 10, alignment: 'center'
      },
      {
        text: activitySummary.period?.description || 'Reporte de actividad',
        alignment: 'center',
        fontSize: 14,
        bold: true,
        margin: [0, 18, 0, 18]
      },

      // Resumen por tipo de contenedor
      {
        text: 'Resumen por tipo de contenedor',
        alignment: 'left',
        fontSize: 12,
        bold: true,
        margin: [0, 10, 0, 5]
      },
      {
        style: 'tableContent',
        table: {
          widths: ['*', 'auto', 'auto', 'auto', 'auto'],
          body: byContainerTypeRows
        },
        margin: [0, 0, 0, 20]
      },

      // Detalle de almacenamiento
      {
        text: 'Detalle de almacenamiento',
        alignment: 'left',
        fontSize: 12,
        bold: true,
        margin: [0, 10, 0, 5]
      },
      {
        style: 'tableContent',
        table: {
          widths: ['*', 'auto', '*', 'auto', 'auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto'],
          headerRows: 1,
          body: [
        storageHeaders,
        ...Array.from(
          new Map(
            storageRows
          .filter(row => row[0]?.text) // Asegura que hay un id/contenedor
          .map(row => [row[0].text, row]) // Usa el campo 'container' como id
          ).values()
        )
          ]
        },
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return (rowIndex % 2 === 0) ? '#EEEEEE' : null;
          }
        },
        margin: [0, 0, 0, 20]
      },

      // Detalle de transbordo
      {
        text: 'Detalle de transbordo',
        alignment: 'left',
        fontSize: 12,
        bold: true,
        margin: [0, 10, 0, 5]
      },
      {
        style: 'tableContent',
        table: {
          widths: ['*', 'auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
          headerRows: 1,
          body: [transshipmentHeaders, ...transshipmentRows]
        },
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return (rowIndex % 2 === 0) ? '#EEEEEE' : null;
          }
        },
        margin: [0, 0, 0, 30]
      },
      // Resumen general
      {
        style: 'tableContent',
        table: {
          widths: ['*', 'auto'],
          body: summaryRows
        },
        margin: [0, 0, 0, 20]
      },

    ],
    styles: {
      headerTableData: {
        bold: true,
        fillColor: '#95A5A6'
      },
      headerTableStatistical: {
        alignment: 'center',
        bold: true,
        fillColor: '#95A5A6',
        margin: [10, 0]
      },
      footer: {
        opacity: 0.4,
        fontSize: 11,
      },
      tableFilter: {
        bold: true,
      },
      tableContent: {
        fontSize: 10
      }
    }
  }
}